import { styled } from 'styled-components'

export const IconWrap = styled.div<{ $bgColor?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : 'var(--primary100)')};
  border-radius: 8px;
`
export const StatusTag = styled.div`
  > div {
    margin-bottom: 8px;

    > span {
      display: flex;
      margin: 0;
    }
  }
`
